import type { PartialMessages } from "../messages";

export const sk: PartialMessages = {
  "status.syncing": "Synchronizované", "status.connecting": "Pripájanie", "status.full": "Plno", "status.closed": "Odpojené",
  "toast.connecting": "Pripájanie…", "toast.reconnecting": "Spojenie sa stratilo. Skúšam znova…",
  "toast.retrying": "O chvíľu to skúsim znova.", "toast.busy": "Práve je veľká premávka",
  "notice.mapChanged": "{name} prepol mapu",
  "hint.place": "Klikni na umiestnenie, ťahaním určíš smer (Esc zruší)",
  "kind.objective": "Cieľ", "kind.rally": "Zraz", "kind.enemy": "Nepriateľ", "kind.loot": "Loot",
  "kind.extract": "Extrakcia", "kind.danger": "Nebezpečenstvo", "kind.self": "Ja", "kind.ping": "Sem!",
  "hint.objective": "Kam idete", "hint.rally": "Miesto zrazu",
  "hint.enemy": "Otoč ho tam, odkiaľ si ho videl", "hint.loot": "Vzácne bedne, telá",
  "hint.extract": "Plánovaná extrakcia", "hint.danger": "Míny, odstreľovači, otvorený terén",
  "hint.self": "Tvoja pozícia. Nová zmaže predošlú",
  "hint.ping": "Dočasná značka, po 25 sekundách zmizne",
  "tool.clearMine": "Zmazať moje", "tool.clearMineHint": "Odstráni všetky značky, ktoré si umiestnil",
  "sidebar.map": "Mapa (pre všetkých)", "sidebar.styleSvg": "Kreslená", "sidebar.styleTile": "Satelit",
  "sidebar.floors": "Poschodie (mení len tvoj pohľad)", "sidebar.groundFloor": "Prízemie",
  "sidebar.floorNote": "Značky z iných poschodí sú zosvetlené.",
  "sidebar.members": "{count} v miestnosti", "sidebar.you": "ty", "sidebar.guest": "hosť",
  "sidebar.clearAll": "Zmazať všetky značky", "sidebar.openWindow": "Otvoriť v okne (len pre mňa)",
  "sidebar.invite": "Pozvať niekoho", "sidebar.help": "Ako na to", "sidebar.feedback": "Poslať spätnú väzbu",
  "sidebar.mapData": "Dáta mapy", "sidebar.license": "Licencia", "sidebar.licenseNote": "len nekomerčné použitie",
  "sidebar.room": "Miestnosť",
  "pin.facing": "Smer", "pin.floor": "Poschodie", "pin.map": "Mapa", "pin.noFacing": "Bez smeru",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "Pridať poznámku (napr. okno na treťom poschodí)",
  "pin.removeMine": "Zmazať túto značku", "pin.removeOther": "Zmazať cudziu značku", "pin.close": "Zavrieť",
  "compass.n": "S", "compass.ne": "SV", "compass.e": "V", "compass.se": "JV",
  "compass.s": "J", "compass.sw": "JZ", "compass.w": "Z", "compass.nw": "SZ",
  "handoff.title": "Otvoriť v okne",
  "handoff.lede": "Odkaz pre teba. Otvorí tú istú miestnosť v prehliadači, aby Discord ďalej ukazoval zdieľanú obrazovku a mapa bola na druhom monitore.",
  "handoff.open": "Otvoriť v prehliadači tohto počítača", "handoff.or": "Na inom zariadení",
  "handoff.codeHint": "Na tom zariadení otvor {host}/j/ a zadaj kód vyššie.",
  "handoff.copy": "Kopírovať odkaz", "handoff.copied": "Skopírované",
  "handoff.copyFailed": "Označené vyššie — stlač Ctrl+C",
  "handoff.expiry": "Odkaz funguje raz. Vyprší o {time}.",
  "handoff.warn": "Neposielaj ho ďalej: otvorením sa minie. Na to slúži „Pozvať niekoho“.",
  "handoff.creating": "Vytváram odkaz…", "handoff.failed": "Odkaz sa nepodarilo vytvoriť",
  "invite.title": "Pozvať niekoho",
  "invite.lede": "Priveď niekoho, kto nie je na hlasovom kanáli. Zadá meno a bude môcť klásť značky.",
  "invite.copy": "Kopírovať odkaz", "invite.warn": "Ktokoľvek s týmto odkazom sa môže pripojiť. Nezverejňuj ho.",
  "invite.budget": "Ešte {left} ľudí, vyprší o {time} (využité {used}/{max}).",
  "invite.revoke": "Zneplatniť odkaz hneď", "invite.revoked": "Odkaz zneplatnený.",
  "invite.creating": "Vytváram odkaz…", "invite.failed": "Odkaz sa nepodarilo vytvoriť",
  "invite.revokeFailed": "Zneplatnenie sa nepodarilo",
  "join.title": "Pripojiť sa k mape",
  "join.lede": "Niekto ťa pozval na mapu raidu. Zvoľ meno — objaví sa pri tvojich značkách.",
  "join.name": "Meno", "join.go": "Pripojiť sa", "join.joining": "Pripájam…", "join.failed": "Pripojenie zlyhalo",
  "feedback.title": "Napísať autorovi", "feedback.request": "Návrh", "feedback.bug": "Chyba",
  "feedback.other": "Iné", "feedback.requestHint": "Bolo by fajn, keby…",
  "feedback.bugHint": "Niečo nefunguje", "feedback.otherHint": "Čokoľvek",
  "feedback.placeholder": "napr. chcel by som kresliť čiary, nielen šípky / na Streets sa neprepínajú poschodia",
  "feedback.note": "So správou sa odošle tvoje meno na Discorde a ID, aby sme mohli odpovedať.",
  "feedback.send": "Odoslať", "feedback.sending": "Odosielam…", "feedback.sent": "Odoslané. Vďaka!",
  "feedback.failed": "Odoslanie zlyhalo",
  "time.minutes": "{n} min", "time.hoursMinutes": "{h} h {m} min",
  "error.roomFull": "Táto miestnosť je plná",
  "error.tooManyWindows": "Priveľa okien tejto miestnosti. Jedno zavri.",
  "error.serverFull": "Server je plný", "error.session": "Relácia už neplatí. Otvor to znova.",
  "error.handoffSpent": "Tento odkaz nefunguje. Je jednorazový a len pre toho, kto ho vytvoril. Ak chceš niekoho pozvať, vytvor na mape pozvánku.",
  "error.inviteSpent": "Táto pozvánka už neplatí. Vypýtaj si nový odkaz.",
  "error.inviteNotOwner": "Zneplatniť odkaz môže len jeho tvorca",
  "error.noRoom": "Nebola zadaná miestnosť", "error.needName": "Zadaj meno",
  "error.tooShort": "Napíš toho prosím trochu viac", "error.tooLong": "Je to príliš dlhé",
  "error.badKind": "Neplatná kategória",
  "error.rateLimited": "Priveľa správ. Počkaj asi 10 minút.",
  "error.busy": "Je veľká premávka. Skús to o chvíľu.",
  "error.sendFailed": "Odoslanie zlyhalo. Skús to neskôr.",
  "error.feedbackClosed": "Spätná väzba je momentálne zatvorená",
  "error.sessionGone": "Pôvodná relácia skončila. Otvor aktivitu znova.",
  "landing.tagline1": "Zdieľaj mapu Tarkova",
  "landing.tagline2": "so všetkými na hovore na Discorde a vysvetlite si ju spolu.",
  "landing.install": "Pridať do Discordu",
  "landing.installNote": "Zadarmo. Spustíš ikonou rakety v hlasovom kanáli.",
  "landing.body": "Všetci na hovore vidia tú istú mapu. Kliknutie položí značku a ťahaním k nej pridáš šípku smeru — ukážeš nielen kde, ale aj kadiaľ.",
  "landing.point1": "Stačí byť na tom istom hovore. Žiadne kódy",
  "landing.point2": "Všetkých 13 máp. Kreslené aj satelitné, a poschodia",
  "landing.point3": "Značky zostávajú, môžeš sa k nim vrátiť",
  "landing.point4": "Kto nie je na hovore, príde cez pozvánku",
  "landing.footNote": "Hry sa to nikdy nedotkne. Žiadne súbory, žiadna pamäť, nič vykreslené cez hru. Každú značku kladie človek ručne.",
  "landing.footCredit": "Hobby projekt, beží zadarmo. Dáta máp z {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov je produkt Battlestate Games Limited; toto je neoficiálny fanúšikovský projekt bez väzby na nich.",
  "landing.updates": "Novinky", "landing.allUpdates": "Všetky novinky",
  "boot.connecting": "Pripájanie k Discordu…", "boot.failedTitle": "Nepodarilo sa spustiť",
};
